<template>
  <section class="register">
    <div class="wrapper">
      <span class="alert alert--danger" style="width: 100%;" v-if="error">{{error}}</span>
      <ValidationObserver v-slot="{ handleSubmit, valid }" ref="formValidator">
        <form @submit.prevent="handleSubmit(register)">
          <div>
            <ValidationProvider name="E-Mail" :rules="{required: true, email: true}" v-slot="{ valid }">
              <label>
                <input type="email" v-model="email" placeholder="E-mail"  v-bind:class="{'invalid': email !== '' && !valid}">
              </label>
            </ValidationProvider>
          </div>
          <div>
            <ValidationProvider name="Password"  :rules="{required: true, min: 5}" v-slot="{ valid }">
              <label>
                <input type="password" v-model="password" placeholder="Password" v-bind:class="{'invalid': password !== '' && !valid}">
              </label>
            </ValidationProvider>
          </div>
          <div>
            <button type="submit" class="button has-icon" :disabled="!valid">
              <span>Create account</span>
              <svg width="21px" height="19px" viewBox="0 0 21 19" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                  <rect id="path-1" x="494" y="509" width="941" height="95" rx="17"></rect>
                  <filter x="-2.4%" y="-23.7%" width="104.8%" height="147.4%" filterUnits="objectBoundingBox" id="filter-2">
                    <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="7.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.128240412 0" type="matrix"
                                   in="shadowBlurOuter1"></feColorMatrix>
                  </filter>
                </defs>
                <g id="GPORTAL-Cloud" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Artboard" transform="translate(-1381.000000, -547.000000)">
                    <g id="Group-2" transform="translate(1196.000000, 529.000000)">
                      <g id="arrow-right" transform="translate(185.000000, 18.000000)" fill="#000000" fill-rule="nonzero">
                        <path
                          d="M21,9.47091187 C20.9985813,8.92574152 20.7631749,8.4072011 20.3531615,8.04609137 L11.4698604,0.257864177 C10.9929043,-0.131067655 10.2923864,-0.0737816791 9.88549323,0.387428356 C9.47860002,0.848638391 9.51156079,1.54802275 9.96004087,1.96923192 L16.8233625,7.98514071 C16.8849821,8.03960302 16.906466,8.12629743 16.8773671,8.20306718 C16.8482682,8.27983692 16.7746245,8.33075258 16.6922466,8.33105547 L1.14428425,8.28356145 C0.512313511,8.28356145 0,8.79389255 0,9.42341785 C0,10.0529432 0.512313511,10.5632743 1.14428425,10.5632743 L16.6898626,10.6107683 C16.7721897,10.6115572 16.8455703,10.6626538 16.8745942,10.739401 C16.9036182,10.8161482 16.8823205,10.9027732 16.8209785,10.9574746 L9.95765694,16.9733834 C9.63074902,17.236408 9.47487151,17.6567617 9.55162798,18.0683187 C9.62838446,18.4798758 9.92542392,18.8164118 10.3253549,18.944926 C10.7252858,19.0734403 11.1637547,18.9732533 11.4674764,18.6839596 L20.3523669,10.8957324 C20.7628432,10.5348904 20.998584,10.0162506 21,9.47091187 Z"
                          id="Path"></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </div>
        </form>
      </ValidationObserver>
      <p>
        By signing up you agree to the <router-link :to="{name: 'PrivacyPolicy'}">Privacy Policy</router-link> and <router-link :to="{name: 'TermsOfService'}">Terms of Service</router-link>.
      </p>
    </div>
  </section>

</template>


<script>
/* eslint max-len: ["error", { "code": 100000 }] */

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import axios from 'axios';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      email: '',
      password: '',
      error: '',
    };
  },
  methods: {
    resetForm() {
      this.email = '';
      this.password = '';
    },
    register() {
      this.error = '';
      let registrationURL = 'https://api.g-portal.cloud/rest/v1/users/register'
      grecaptcha.ready(() => {
        grecaptcha.execute('6LfWCtIZAAAAAJog2zxRaFJFMb-aSnxSalItZxMz', {action: 'register'}).then((token) => {
          axios.post(registrationURL, {
            email: this.email,
            password: this.password,
            recaptcha_token: token,
          }).then((response) => {
            window.location.replace(`https://panel.g-portal.cloud/#/login?accessToken=${response.data.access_token}&refreshToken=${response.data.refresh_token}`)
          }).catch((error) => {
            this.error = error.response.data.message;
          }).finally(() => {
            this.resetForm();
          });
        });
      });
    },
  },
  mounted() {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/Register.vue